// extracted by mini-css-extract-plugin
export default {"title":"_450ceed09a","bld":"fcd6a37ae3"};